<template>
   
     <!-- Section: testimonial -->
    <section id="news_slider" class="home-section paddingbot-60 parallax">
     
      <div class="container">
         <div>
          <i class="fa info-circle" style="color:#4ACCD1;"></i>        
        </div>
      <slick
        ref="slick"
        :options="slickOptions" v-if="newsList.length">
        
        <div v-for="newsObj in this.newsList" v-bind:key="newsObj._id" class="slide-box">
          <h3 v-html="newsObj.title" :style="$store.getters.CURRENT_LANGUAGE === 'ru_RU'? 'direction: ltr;': 'direction: rtl;'">{{newsObj.title}}</h3>
          <div v-html="newsObj.description" :style="$store.getters.CURRENT_LANGUAGE === 'ru_RU'? 'direction: ltr;': 'direction: rtl;'">{{newsObj.description}}</div>
        </div>
        
         <!-- <a v-for="videoObj in this.listVideo" v-bind:key="videoObj._id" href="http://placehold.it/300x270"><img src="http://placehold.it/440x300" alt=""></a>-->
          <!--<div class="video-wrapper">
          
          </div>-->
        
      </slick>
      </div>
    </section>
    <!-- /Section: testimonial -->

</template>

<script>
import { getDataFromServerWithHeader, getDataFromServer } from '../utils/DataProvider';
import Slick from 'vue-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
  export default {
    components: { Slick },

    data: () => ({
        newsList:[],
        slickOptions: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding:'0px',
                rtl: false,
                arrows:true,
                autoplay: true,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear'
            },
                
    }),
    methods:{
        getCommentsList(){
            console.log("get comments by lang and place: ", this.$store.getters.CURRENT_LANGUAGE)
            getDataFromServer('list_comments_byplace', {place:'1', language: this.$store.getters.CURRENT_LANGUAGE})
            .then(obj => 
            {
            console.log("response success : ", obj.data.success);
            if(obj.data.success === true){
                console.log("response list_comments: ", obj.data.data);              
                this.newsList = obj.data.data;
                
                if(this.$refs.slick !== undefined){
                  this.reInit();
                }
            }
            else{
                this.flash('get comments error: ' + obj.data.text , 'error', {timeout: 4000})
            }          
            })
            .catch(err => {
            console.log("response : ", err);
            this.flash('get comments error: ' + err, 'error', {timeout: 4000})
            })
        },
        reInit() {
          let currIndex = this.$refs.slick.currentSlide()
          this.$refs.slick.destroy()
          this.$nextTick(() => {
          this.$refs.slick.create()
          this.$refs.slick.goTo(currIndex, true)
        })
      }
    },
    created(){
      this.$store.subscribe((mutation, state) => {
          if(mutation.type === 'SET_CURRENT_LANGUAGE'){             
             console.log("sub for lang change")
             this.getCommentsList()
          }
      })
     console.log("sub for lang change 2") 
      this.getCommentsList()
    }
  }
</script>

<style scoped>
.slide-box{
    background-color: #f2f2f2;
    border-radius: 7px;
    padding: 10px;
    text-align: center;
}
</style>